import { FeedbackRequestsService } from '../services/feedback-requests.service';

export const AllServices = [
  FeedbackRequestsService
];

export * from '../services/feedback-requests.service';
